import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  Button, Card, Col, Form, Row,
} from 'antd';
import IStickyBox from 'react-sticky-box';
import { useTranslation } from 'react-i18next';
import { antNotification, capitalize } from '../../mainUtils';
import { ApiContext } from '../../api/ApiContextProvider';
import CertificateForm from './CertificateForm';
import BaseCard from '../../_ui/BaseCard/BaseCard';
import BaseButton from '../../_ui/BaseButton/BaseButton';

function CertificateCreate({
  switchView,
  onSuccessCreate,
}) {
  const { t } = useTranslation();
  const [certificateForm] = Form.useForm();

  const { requestCreateCertificate } = useContext(ApiContext);

  const onSubmitForm = async () => {
    try {
      const formData = await certificateForm.validateFields();

      requestCreateCertificate(formData).then(() => {
        antNotification.success(capitalize(t('auth.notifications.added_successfully', 'added successfully')));
        onSuccessCreate();
      });
    } catch (error) {
      antNotification.error(capitalize(t('auth.notifications.invalid_data', 'invalid data entered')));
    }
  };

  return (
    <IStickyBox offsetTop={16} offsetBottom={16}>
      <BaseCard>
        <Row>
          <Col span={24}>
            <h4 className="header-primary">
              {capitalize(t('auth.headers.create_certificate', 'creating new certificate'))}
            </h4>
          </Col>
        </Row>
        <hr className="my-6" />
        <Row>
          <Col span={24}>
            <CertificateForm
              form={certificateForm}
            />
          </Col>
        </Row>
        <hr className="my-6" />
        <Row>
          <Col className="mr-auto">
            <BaseButton
              className="button-primary"
              onClick={onSubmitForm}
            >
              {capitalize(t('auth.buttons.create_certificate', 'create certificate'))}
            </BaseButton>
            <BaseButton
              className="button-secondary-outlined ml-2"
              onClick={() => switchView()}
            >
              {capitalize(t('auth.buttons.cancel', 'cancel'))}
            </BaseButton>
          </Col>
        </Row>
      </BaseCard>
    </IStickyBox>
  );
}

export default CertificateCreate;

CertificateCreate.propTypes = {
  onSuccessCreate: PropTypes.func.isRequired,
  switchView: PropTypes.func.isRequired,
};
